const Form005PICSTC = {
    picsTitle: "個人資料收集聲明",
    subtitleList: [
        { text: "收集個人資料的目的" },
        { text: "可獲轉移資料者" },
        { text: "查閱個人資料" },
    ],
    symbolStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
    ],
    firstStep: [
        {
            text: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        },
        {
            text: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理有關表格。",
        },
        {
            text: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        },
        {
            text: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港灣仔皇后大道東213號胡忠大廈11樓1141室教育局學生特別支援組行政主任（學生特別支援）11或電郵至<a href='mailto: exosss11@edb.gov.hk'>exosss11@edb.gov.hk</a>。",
        },
    ],
    secondStep: [
        {
            text: "處理、核實、審核資格及查證各項補助和津貼，以及由教育局提供的教育服務的表格；",
        },
        {
            text: "就上文(a)項所述表格的處理、核實、審核資格及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
        },
        {
            text: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；以及",
        },
        {
            text: "編製統計資料、研究及政府刊物。",
        },
    ],
    thirdStep: [
        {
            text: "政府其他政策局及部門，以用於上文第1段所述的用途；",
        },
        {
            text: "與本表格相關的學校，以用於上文第1段所述的用途；",
        },
        {
            text: "受聘於教育局以提供服務或意見的人員、代理人、服務供應商或機構，包括校本課後學習及支援計劃委員會會員，以用於上文第1段所述的用途。",
        },
        {
            text: "你曾就披露個人資料給予訂明同意；以及",
        },
        {
            text: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
    ],
};
export default Form005PICSTC;
